/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CreatePostCommentRequest,
    CreatePostRequest,
    IdResponse,
    ModerateStorePostByAdminRequest,
    ModerateStorePostByAiRequest,
    ModerateStorePostRequest,
    StoreHasPostsResponse,
    ToggleHiddenPostRequest,
    UpdatePostCommentRequest,
    UpdatePostRequest,
} from '../models';

export interface PostApiControllerCreatePostRequest {
    storeId: string;
    createPostRequest: CreatePostRequest;
}

export interface PostApiControllerCreatePostCommentRequest {
    storeId: string;
    postId: string;
    createPostCommentRequest: CreatePostCommentRequest;
}

export interface PostApiControllerDeletePostRequest {
    storeId: string;
    id: string;
}

export interface PostApiControllerDeletePostCommentRequest {
    storeId: string;
    postId: string;
    commentId: string;
}

export interface PostApiControllerHasPostsRequest {
    sellerId: string;
}

export interface PostApiControllerLikePostRequest {
    storeId: string;
    id: string;
}

export interface PostApiControllerLikePostCommentRequest {
    storeId: string;
    postId: string;
    commentId: string;
}

export interface PostApiControllerModeratePostRequest {
    storeId: string;
    id: string;
    moderateStorePostRequest: ModerateStorePostRequest;
}

export interface PostApiControllerModeratePostByAdminRequest {
    storeId: string;
    postId: string;
    moderateStorePostByAdminRequest: ModerateStorePostByAdminRequest;
}

export interface PostApiControllerModeratePostByAiRequest {
    storeId: string;
    cid: string;
    xApiKey: string;
    moderateStorePostByAiRequest: ModerateStorePostByAiRequest;
}

export interface PostApiControllerPinPostRequest {
    storeId: string;
    id: string;
}

export interface PostApiControllerToggleHiddenPostRequest {
    storeId: string;
    id: string;
    toggleHiddenPostRequest: ToggleHiddenPostRequest;
}

export interface PostApiControllerUnlikePostRequest {
    storeId: string;
    id: string;
}

export interface PostApiControllerUnlikePostCommentRequest {
    storeId: string;
    postId: string;
    commentId: string;
}

export interface PostApiControllerUnpinPostRequest {
    storeId: string;
    id: string;
}

export interface PostApiControllerUpdatePostRequest {
    storeId: string;
    id: string;
    updatePostRequest: UpdatePostRequest;
}

export interface PostApiControllerUpdatePostCommentRequest {
    storeId: string;
    postId: string;
    commentId: string;
    updatePostCommentRequest: UpdatePostCommentRequest;
}

/**
 * 
 */
export class PostsApi extends runtime.BaseAPI {

    /**
     */
    async postApiControllerCreatePostRaw(requestParameters: PostApiControllerCreatePostRequest): Promise<runtime.ApiResponse<IdResponse>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling postApiControllerCreatePost.');
        }

        if (requestParameters.createPostRequest === null || requestParameters.createPostRequest === undefined) {
            throw new runtime.RequiredError('createPostRequest','Required parameter requestParameters.createPostRequest was null or undefined when calling postApiControllerCreatePost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/posts`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createPostRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async postApiControllerCreatePost(requestParameters: PostApiControllerCreatePostRequest): Promise<IdResponse> {
        const response = await this.postApiControllerCreatePostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async postApiControllerCreatePostCommentRaw(requestParameters: PostApiControllerCreatePostCommentRequest): Promise<runtime.ApiResponse<IdResponse>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling postApiControllerCreatePostComment.');
        }

        if (requestParameters.postId === null || requestParameters.postId === undefined) {
            throw new runtime.RequiredError('postId','Required parameter requestParameters.postId was null or undefined when calling postApiControllerCreatePostComment.');
        }

        if (requestParameters.createPostCommentRequest === null || requestParameters.createPostCommentRequest === undefined) {
            throw new runtime.RequiredError('createPostCommentRequest','Required parameter requestParameters.createPostCommentRequest was null or undefined when calling postApiControllerCreatePostComment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/posts/{postId}/comments`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))).replace(`{${"postId"}}`, encodeURIComponent(String(requestParameters.postId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createPostCommentRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async postApiControllerCreatePostComment(requestParameters: PostApiControllerCreatePostCommentRequest): Promise<IdResponse> {
        const response = await this.postApiControllerCreatePostCommentRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async postApiControllerDeletePostRaw(requestParameters: PostApiControllerDeletePostRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling postApiControllerDeletePost.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postApiControllerDeletePost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/posts/{id}`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async postApiControllerDeletePost(requestParameters: PostApiControllerDeletePostRequest): Promise<void> {
        await this.postApiControllerDeletePostRaw(requestParameters);
    }

    /**
     */
    async postApiControllerDeletePostCommentRaw(requestParameters: PostApiControllerDeletePostCommentRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling postApiControllerDeletePostComment.');
        }

        if (requestParameters.postId === null || requestParameters.postId === undefined) {
            throw new runtime.RequiredError('postId','Required parameter requestParameters.postId was null or undefined when calling postApiControllerDeletePostComment.');
        }

        if (requestParameters.commentId === null || requestParameters.commentId === undefined) {
            throw new runtime.RequiredError('commentId','Required parameter requestParameters.commentId was null or undefined when calling postApiControllerDeletePostComment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/posts/{postId}/comments/{commentId}`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))).replace(`{${"postId"}}`, encodeURIComponent(String(requestParameters.postId))).replace(`{${"commentId"}}`, encodeURIComponent(String(requestParameters.commentId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async postApiControllerDeletePostComment(requestParameters: PostApiControllerDeletePostCommentRequest): Promise<void> {
        await this.postApiControllerDeletePostCommentRaw(requestParameters);
    }

    /**
     */
    async postApiControllerHasPostsRaw(requestParameters: PostApiControllerHasPostsRequest): Promise<runtime.ApiResponse<StoreHasPostsResponse>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling postApiControllerHasPosts.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}:hasPosts`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async postApiControllerHasPosts(requestParameters: PostApiControllerHasPostsRequest): Promise<StoreHasPostsResponse> {
        const response = await this.postApiControllerHasPostsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async postApiControllerLikePostRaw(requestParameters: PostApiControllerLikePostRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling postApiControllerLikePost.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postApiControllerLikePost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/posts/{id}:like`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async postApiControllerLikePost(requestParameters: PostApiControllerLikePostRequest): Promise<void> {
        await this.postApiControllerLikePostRaw(requestParameters);
    }

    /**
     */
    async postApiControllerLikePostCommentRaw(requestParameters: PostApiControllerLikePostCommentRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling postApiControllerLikePostComment.');
        }

        if (requestParameters.postId === null || requestParameters.postId === undefined) {
            throw new runtime.RequiredError('postId','Required parameter requestParameters.postId was null or undefined when calling postApiControllerLikePostComment.');
        }

        if (requestParameters.commentId === null || requestParameters.commentId === undefined) {
            throw new runtime.RequiredError('commentId','Required parameter requestParameters.commentId was null or undefined when calling postApiControllerLikePostComment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/posts/{postId}/comments/{commentId}:like`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))).replace(`{${"postId"}}`, encodeURIComponent(String(requestParameters.postId))).replace(`{${"commentId"}}`, encodeURIComponent(String(requestParameters.commentId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async postApiControllerLikePostComment(requestParameters: PostApiControllerLikePostCommentRequest): Promise<void> {
        await this.postApiControllerLikePostCommentRaw(requestParameters);
    }

    /**
     */
    async postApiControllerModeratePostRaw(requestParameters: PostApiControllerModeratePostRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling postApiControllerModeratePost.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postApiControllerModeratePost.');
        }

        if (requestParameters.moderateStorePostRequest === null || requestParameters.moderateStorePostRequest === undefined) {
            throw new runtime.RequiredError('moderateStorePostRequest','Required parameter requestParameters.moderateStorePostRequest was null or undefined when calling postApiControllerModeratePost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/posts/{id}:moderate`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.moderateStorePostRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async postApiControllerModeratePost(requestParameters: PostApiControllerModeratePostRequest): Promise<void> {
        await this.postApiControllerModeratePostRaw(requestParameters);
    }

    /**
     */
    async postApiControllerModeratePostByAdminRaw(requestParameters: PostApiControllerModeratePostByAdminRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling postApiControllerModeratePostByAdmin.');
        }

        if (requestParameters.postId === null || requestParameters.postId === undefined) {
            throw new runtime.RequiredError('postId','Required parameter requestParameters.postId was null or undefined when calling postApiControllerModeratePostByAdmin.');
        }

        if (requestParameters.moderateStorePostByAdminRequest === null || requestParameters.moderateStorePostByAdminRequest === undefined) {
            throw new runtime.RequiredError('moderateStorePostByAdminRequest','Required parameter requestParameters.moderateStorePostByAdminRequest was null or undefined when calling postApiControllerModeratePostByAdmin.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/posts/{postId}:adminModerate`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))).replace(`{${"postId"}}`, encodeURIComponent(String(requestParameters.postId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.moderateStorePostByAdminRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async postApiControllerModeratePostByAdmin(requestParameters: PostApiControllerModeratePostByAdminRequest): Promise<void> {
        await this.postApiControllerModeratePostByAdminRaw(requestParameters);
    }

    /**
     */
    async postApiControllerModeratePostByAiRaw(requestParameters: PostApiControllerModeratePostByAiRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling postApiControllerModeratePostByAi.');
        }

        if (requestParameters.cid === null || requestParameters.cid === undefined) {
            throw new runtime.RequiredError('cid','Required parameter requestParameters.cid was null or undefined when calling postApiControllerModeratePostByAi.');
        }

        if (requestParameters.xApiKey === null || requestParameters.xApiKey === undefined) {
            throw new runtime.RequiredError('xApiKey','Required parameter requestParameters.xApiKey was null or undefined when calling postApiControllerModeratePostByAi.');
        }

        if (requestParameters.moderateStorePostByAiRequest === null || requestParameters.moderateStorePostByAiRequest === undefined) {
            throw new runtime.RequiredError('moderateStorePostByAiRequest','Required parameter requestParameters.moderateStorePostByAiRequest was null or undefined when calling postApiControllerModeratePostByAi.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApiKey !== undefined && requestParameters.xApiKey !== null) {
            headerParameters['x-api-key'] = String(requestParameters.xApiKey);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/posts/{cid}:aiModerate`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))).replace(`{${"cid"}}`, encodeURIComponent(String(requestParameters.cid))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.moderateStorePostByAiRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async postApiControllerModeratePostByAi(requestParameters: PostApiControllerModeratePostByAiRequest): Promise<void> {
        await this.postApiControllerModeratePostByAiRaw(requestParameters);
    }

    /**
     */
    async postApiControllerPinPostRaw(requestParameters: PostApiControllerPinPostRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling postApiControllerPinPost.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postApiControllerPinPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/posts/{id}:pin`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async postApiControllerPinPost(requestParameters: PostApiControllerPinPostRequest): Promise<void> {
        await this.postApiControllerPinPostRaw(requestParameters);
    }

    /**
     */
    async postApiControllerToggleHiddenPostRaw(requestParameters: PostApiControllerToggleHiddenPostRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling postApiControllerToggleHiddenPost.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postApiControllerToggleHiddenPost.');
        }

        if (requestParameters.toggleHiddenPostRequest === null || requestParameters.toggleHiddenPostRequest === undefined) {
            throw new runtime.RequiredError('toggleHiddenPostRequest','Required parameter requestParameters.toggleHiddenPostRequest was null or undefined when calling postApiControllerToggleHiddenPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/posts/{id}:toggleHidden`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.toggleHiddenPostRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async postApiControllerToggleHiddenPost(requestParameters: PostApiControllerToggleHiddenPostRequest): Promise<void> {
        await this.postApiControllerToggleHiddenPostRaw(requestParameters);
    }

    /**
     */
    async postApiControllerUnlikePostRaw(requestParameters: PostApiControllerUnlikePostRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling postApiControllerUnlikePost.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postApiControllerUnlikePost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/posts/{id}:unlike`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async postApiControllerUnlikePost(requestParameters: PostApiControllerUnlikePostRequest): Promise<void> {
        await this.postApiControllerUnlikePostRaw(requestParameters);
    }

    /**
     */
    async postApiControllerUnlikePostCommentRaw(requestParameters: PostApiControllerUnlikePostCommentRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling postApiControllerUnlikePostComment.');
        }

        if (requestParameters.postId === null || requestParameters.postId === undefined) {
            throw new runtime.RequiredError('postId','Required parameter requestParameters.postId was null or undefined when calling postApiControllerUnlikePostComment.');
        }

        if (requestParameters.commentId === null || requestParameters.commentId === undefined) {
            throw new runtime.RequiredError('commentId','Required parameter requestParameters.commentId was null or undefined when calling postApiControllerUnlikePostComment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/posts/{postId}/comments/{commentId}:unlike`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))).replace(`{${"postId"}}`, encodeURIComponent(String(requestParameters.postId))).replace(`{${"commentId"}}`, encodeURIComponent(String(requestParameters.commentId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async postApiControllerUnlikePostComment(requestParameters: PostApiControllerUnlikePostCommentRequest): Promise<void> {
        await this.postApiControllerUnlikePostCommentRaw(requestParameters);
    }

    /**
     */
    async postApiControllerUnpinPostRaw(requestParameters: PostApiControllerUnpinPostRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling postApiControllerUnpinPost.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postApiControllerUnpinPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/posts/{id}:unpin`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async postApiControllerUnpinPost(requestParameters: PostApiControllerUnpinPostRequest): Promise<void> {
        await this.postApiControllerUnpinPostRaw(requestParameters);
    }

    /**
     */
    async postApiControllerUpdatePostRaw(requestParameters: PostApiControllerUpdatePostRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling postApiControllerUpdatePost.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postApiControllerUpdatePost.');
        }

        if (requestParameters.updatePostRequest === null || requestParameters.updatePostRequest === undefined) {
            throw new runtime.RequiredError('updatePostRequest','Required parameter requestParameters.updatePostRequest was null or undefined when calling postApiControllerUpdatePost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/posts/{id}`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.updatePostRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async postApiControllerUpdatePost(requestParameters: PostApiControllerUpdatePostRequest): Promise<void> {
        await this.postApiControllerUpdatePostRaw(requestParameters);
    }

    /**
     */
    async postApiControllerUpdatePostCommentRaw(requestParameters: PostApiControllerUpdatePostCommentRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling postApiControllerUpdatePostComment.');
        }

        if (requestParameters.postId === null || requestParameters.postId === undefined) {
            throw new runtime.RequiredError('postId','Required parameter requestParameters.postId was null or undefined when calling postApiControllerUpdatePostComment.');
        }

        if (requestParameters.commentId === null || requestParameters.commentId === undefined) {
            throw new runtime.RequiredError('commentId','Required parameter requestParameters.commentId was null or undefined when calling postApiControllerUpdatePostComment.');
        }

        if (requestParameters.updatePostCommentRequest === null || requestParameters.updatePostCommentRequest === undefined) {
            throw new runtime.RequiredError('updatePostCommentRequest','Required parameter requestParameters.updatePostCommentRequest was null or undefined when calling postApiControllerUpdatePostComment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/posts/{postId}/comments/{commentId}`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))).replace(`{${"postId"}}`, encodeURIComponent(String(requestParameters.postId))).replace(`{${"commentId"}}`, encodeURIComponent(String(requestParameters.commentId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.updatePostCommentRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async postApiControllerUpdatePostComment(requestParameters: PostApiControllerUpdatePostCommentRequest): Promise<void> {
        await this.postApiControllerUpdatePostCommentRaw(requestParameters);
    }

}
